import React from 'react';
import { ScreenFilters } from './components/ScreenFilters';
import { ContainerPOS } from './styles';
import FormDefault from '~/components/FormDefault';
import { Row } from 'react-bootstrap';
import { ActButtons } from './components/ActButtons';
import { DataGrid, GridCellParams, GridColumns } from '@material-ui/data-grid';
import { SeparatorNovo } from '~/components/SeparatorNovo';
import { InputsDestino } from './components/InputsDestino';
import { CustomButtonNovo } from '~/components/Buttons/CustomButtonNovo';
import { FaExchangeAlt } from 'react-icons/fa';
import { useTransferenciaDePOS } from './contexts/TransferenciaDePOSContext';
import {
  actionsCol,
  dateCol,
  makeCol,
  numCol,
  textCol,
  TituloRow,
} from './utils/tabColumns';
import { moneyFormat } from '~/utils/functions';

export const TransferenciaDePOSContent: React.FC = () => {
  const {
    showContent,
    handleTransferir,
    titulosElegiveis,
    isSelected,
    toggleSelection,
    clearSelection,
    selectAll,
    selectedTotal,
    selectedRows,
    transferindo,
  } = useTransferenciaDePOS();

  const buildTabColumns = (): GridColumns => {
    return [
      makeCol({ field: 'id', headerName: 'ID', hide: true }),

      actionsCol({
        field: 'transferir',
        headerName: 'Transferir?',
        renderCell: (params: GridCellParams) => {
          const row = params.row as TituloRow;
          const checkboxId = `transferir-${row.id}`;
          const checked = isSelected(String(row.id));

          return (
            <input
              id={checkboxId}
              name={checkboxId}
              type="checkbox"
              checked={checked}
              onChange={(e) => {
                e.stopPropagation();
                toggleSelection(row);
              }}
              disabled={transferindo}
              aria-checked={checked}
              aria-label={`Marcar para transferir o documento ${row.num_docto}`}
            />
          );
        },
      }),

      numCol({ field: 'cod_loja', headerName: 'Loja', width: 95 }),
      numCol({ field: 'num_docto', headerName: 'Docto' }),

      textCol({ field: 'nome_pessoa', headerName: 'Parceiro', minWidth: 220 }),
      textCol({
        field: 'des_finalizadora',
        headerName: 'Entidade',
        flex: 0.8,
        minWidth: 160,
      }),
      textCol({ field: 'tipo_operacao_cartao', hide: true }),
      textCol({ field: 'cod_conta_receber', hide: true }),
      textCol({ field: 'cod_parcela_receber', hide: true }),

      numCol({ field: 'val_parcela', headerName: 'Valor', width: 120 }),
      numCol({ field: 'val_juros', headerName: 'Juros', width: 110 }),

      dateCol({ field: 'dta_entrada', headerName: 'Entrada' }),
      dateCol({
        field: 'dta_vencimento',
        headerName: 'Vencimento',
        width: 150,
      }),
    ];
  };

  return (
    <ContainerPOS>
      <FormDefault
        codTela={320}
        title="Transferência de P.O.S."
        onSave={() => Promise.resolve()}
        onCancel={() => []}
        onClearFields={() => []}
        onNew={() => []}
        onDelete={() => []}
        onReturnSearch={() => []}
        isDelete={false}
        isClear={false}
        isSave
        isNew={false}
        isCancel={false}
      >
        <Row>
          <ScreenFilters />
          <div className="act-buttons">
            <ActButtons />
          </div>
          {showContent && (
            <div className="content-show">
              <SeparatorNovo
                childrenPosition="right"
                childrenBorder={false}
                marginTop={15}
              >
                <div
                  className="act-button-marcar-desmarcar-todos"
                  role="group"
                  aria-label="Selecionar itens"
                >
                  <button
                    type="button"
                    onClick={clearSelection}
                    disabled={selectedRows.length === 0 || transferindo}
                  >
                    Desmarcar Todos
                  </button>
                  |
                  <button
                    type="button"
                    onClick={selectAll}
                    disabled={
                      titulosElegiveis.length === selectedRows.length ||
                      transferindo
                    }
                  >
                    Marcar Todos
                  </button>
                </div>
              </SeparatorNovo>

              <DataGrid
                className="DataGrid"
                style={{ height: '20.3125rem' }}
                rows={titulosElegiveis}
                columns={buildTabColumns()}
                pageSize={5}
                columnBuffer={10}
                autoHeight
                disableColumnMenu
                disableColumnSelector
                disableColumnFilter
                disableSelectionOnClick
                onRowClick={(p, e) => e.defaultPrevented}
                localeText={{
                  noRowsLabel: 'Nenhum registro encontrado...',
                  columnMenuLabel: 'Menu',
                  columnMenuFilter: 'Filtrar',
                  columnMenuHideColumn: 'Esconder',
                  columnMenuUnsort: 'Não ordenar',
                  columnMenuSortAsc: 'Ordernar ASC',
                  columnMenuSortDesc: 'Ordernar DESC',
                  columnMenuShowColumns: 'Mostrar colunas',
                }}
              />

              <SeparatorNovo
                leftLabel="Destino"
                childrenPosition="right"
                childrenBorder={false}
                marginBottom={15}
              >
                <span style={{ fontSize: '1.25rem' }}>
                  Selecionados: R$ {moneyFormat(selectedTotal.toFixed(2))}
                </span>
              </SeparatorNovo>

              <InputsDestino />
              <div className="btn-transferir">
                <CustomButtonNovo
                  onClick={async () => {
                    await handleTransferir();
                  }}
                  label="Transferir"
                  icon={FaExchangeAlt}
                  showLoading={transferindo}
                  disabled={transferindo}
                />
              </div>
            </div>
          )}
        </Row>
      </FormDefault>
    </ContainerPOS>
  );
};
